export enum LoanStatus {
    Draft = 'Draft',
    Active = 'Active',
    Closed = 'Closed',
    Cancelled = 'Cancelled',
}
